export function ExclamationMarkOutlineSVG({
    className
}: {
    className?: string;
}) {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.9218 0.622012C10.4958 -0.207988 9.50376 -0.207988 9.07776 0.622012L0.167759 17.976C-0.286241 18.856 0.234759 20 1.08876 20H18.9108C19.7648 20 20.2858 18.856 19.8328 17.976L10.9228 0.622012H10.9218ZM10.0068 3.50201L17.4998 18H2.50176L10.0068 3.50201V3.50201ZM8.49976 15.5C8.49976 15.8978 8.65779 16.2794 8.9391 16.5607C9.2204 16.842 9.60193 17 9.99976 17C10.3976 17 10.7791 16.842 11.0604 16.5607C11.3417 16.2794 11.4998 15.8978 11.4998 15.5C11.4998 15.1022 11.3417 14.7207 11.0604 14.4394C10.7791 14.158 10.3976 14 9.99976 14C9.60193 14 9.2204 14.158 8.9391 14.4394C8.65779 14.7207 8.49976 15.1022 8.49976 15.5V15.5ZM8.99976 12C8.99976 12.666 9.33376 13 9.99976 13C10.6668 13 10.9998 12.666 10.9998 12V8.00001C10.9998 7.33301 10.6668 7.00001 9.99976 7.00001C9.33376 7.00001 8.99976 7.33301 8.99976 8.00001V12Z"
                fill="#FB5950"
            />
        </svg>
    );
}
